import { publishElementsDataType } from '../../Pages/Flo/Flo.types';
import React, {
	CSSProperties,
	useCallback,
	useEffect,
	useState,
	useLayoutEffect,
	useMemo,
} from 'react';
import { get } from 'lodash';
import styles from './TextElement.module.css';
import classNames from 'classnames';
import DynamicFontLoader from './TextFontLoader';
import { calculateScaleValue } from '../../utils/video.utils';
import { element } from 'prop-types';

const fontFactor = 600;

export const GuideTextElement = ({
	currentElement,
	currentElementIndex,
	playerDim,
	width: vWidth,
	height: vHeight,
	isDocument,
	floId,
	floIndex,
}: {
	currentElementIndex?: number;
	currentElement?: publishElementsDataType | null;
	playerDim: {
		width: number;
		height: number;
	};
	width: number;
	height: number;
	isWidthLessThan650?: boolean;
	isDocument?: boolean;
	floId: string;
	floIndex: number;
}) => {
	const { addFont } = DynamicFontLoader();

	const txtStyle = {
		fontFamily: get(currentElement, 'properties.fontName') || 'Roboto', // Default to Arial if fontFamily is not provided
		color: get(currentElement, 'properties.fontColor') || 'black', // Default to black if color is not provided
	};

	const textWindowWidth = get(
		currentElement,
		'properties.canvasRenderConfig.windowCoordinates.width',
		0
	);
	const textWindowHeight = get(
		currentElement,
		'properties.canvasRenderConfig.windowCoordinates.height',
		0
	);
	const textX = get(
		currentElement,
		'properties.canvasRenderConfig.canvasCoordinates.x',
		0
	);
	const textY = get(
		currentElement,
		'properties.canvasRenderConfig.canvasCoordinates.y',
		0
	);

	const transformedCoordinates = useMemo(() => {
		console.log('calculating ....', element);
		const widthScale = vWidth / fontFactor;
		const heightScale = vHeight / fontFactor;
		const averageScale = (widthScale + heightScale) / 2;
		const newFontSize = get(currentElement, 'properties.fontSize', 8) * averageScale;

		return {
			x: calculateScaleValue(textWindowWidth, vWidth, textX),
			y: calculateScaleValue(textWindowHeight, vHeight, textY),
			fontSize: newFontSize,
		};
	}, [vWidth, vHeight, element, textWindowWidth, textWindowHeight, textX, textY]);

	useEffect(() => {
		//@ts-ignore
		console.log('loading text', currentElement?.text, currentElement?.time);
		addFont(get(currentElement, 'properties.fontName', 'Inter'));
	}, [currentElement]);

	return (
		<div className={styles.textContainer}>
			<div
				key={get(currentElement, 'id')} // Added key for each element
				className={styles.sizeCalculator}
				style={{
					fontSize: `${transformedCoordinates.fontSize}px`,
					color: get(currentElement, 'properties.fontColor', 'white'),
					transform: `translate(${transformedCoordinates.x}px, ${
						transformedCoordinates.y
					}px) rotate(${get(
						currentElement,
						'properties.canvasRenderConfig.canvasCoordinates.angle',
						0
					)}deg)`,
					//@ts-ignore
					'--calculated-font-size': `${transformedCoordinates.fontSize}px`,
					'--calculated-font-family': get(currentElement, 'properties.fontName', 'Inter'),
				}}
				dangerouslySetInnerHTML={{ __html: get(currentElement, 'properties.text', '') }}
			></div>
		</div>
	);
};
